import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Super admin must choose a client to scope Stage 2-4 pages.
 * Client users are implicitly scoped to their own client.
 * Returns { isSuper, clientId, clients, ClientPicker, scopeParam }.
 */
export function useClientScope() {
  const { user } = useAuth();
  const isSuper = user?.role === "super_admin";
  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState("");

  useEffect(() => {
    if (isSuper) {
      api.get("/clients").then(({ data }) => {
        setClients(data);
        if (data.length && !clientId) setClientId(data[0].id);
      }).catch(() => {});
    }
  }, [isSuper]); // eslint-disable-line

  const scopeParam = isSuper && clientId ? `client_id=${clientId}` : "";
  const ready = !isSuper || !!clientId;

  const ClientPicker = () =>
    isSuper ? (
      <div className="inline-flex items-center gap-2" data-testid="client-scope-picker">
        <span className="text-xs font-semibold text-slate-500">Client:</span>
        <select
          value={clientId}
          onChange={(e) => setClientId(e.target.value)}
          className="px-3 py-1.5 rounded-lg border border-input bg-card text-sm font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
        >
          {clients.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>
    ) : null;

  return { isSuper, clientId, clients, ClientPicker, scopeParam, ready };
}
